import { Box } from '@material-ui/core';
import { fetchCRMbutton, fetchCRMinfo } from '@src/reducers/chats';
import {
  activeChatSelector,
  activeChatSideSelector,
  crmButtonSelector,
} from '@src/selectors/chats';
import { ChatSideType } from '@src/types/chats';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionButtons, { ActionButtonsType } from './ActionButtons';

type CRMButtonProps = {
  areOngoingChats: boolean;
  showCRMbutton: boolean;
  disabled: boolean;
  id: string;
  sendInfo: string;
  handleClick: () => void;
};

const CRMButtonWrapper: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const { id } = useSelector(activeChatSelector);
  const { show: showCRMbutton, sendInfo } = useSelector(crmButtonSelector);
  const areOngoingChats =
    useSelector(activeChatSideSelector) === ChatSideType.ON_HOLD;

  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(fetchCRMbutton(id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <CRMButton
      areOngoingChats={areOngoingChats}
      showCRMbutton={showCRMbutton}
      disabled={disabled}
      id={id}
      sendInfo={sendInfo}
      handleClick={() => dispatch(fetchCRMinfo(id))}
    />
  );
};

export const CRMButton: FC<CRMButtonProps> = ({
  areOngoingChats,
  showCRMbutton,
  disabled,
  id,
  sendInfo,
  handleClick,
}) => {
  if (showCRMbutton && areOngoingChats && id) {
    return (
      <Box display="flex" alignItems="center" gridGap={5}>
        <ActionButtons
          type={'crm' as ActionButtonsType}
          onClick={handleClick}
          disabled={disabled || sendInfo === 'loading'}
          status={sendInfo}
        />
      </Box>
    );
  }

  return null;
};

export default CRMButtonWrapper;
